<template>
  <div class="container">
    <div v-if="currentUser.acl.includes('*')">
      <h1>Sistema de Gestión</h1>
    </div>
    <div v-else>
      <div class="container" v-if="success">
        <list-panel :moves="moves"/>	
		    <highcharts :options="chartOptions"></highcharts>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import {Chart} from 'highcharts-vue'
import ListPanel from '@/components/widgets/General/ListPanel/index'
import ReportService from '../../../services/report.service'
import permission from '../../../mixins/permission'

export default {
  data() {
    return {
      moves: null,
      items:[],
      chartOptions: null,
      success: false,
    }
  },

  computed: mapGetters([
    'currentUser'
  ]),

  mixins: [permission],

  created() {
  	Promise.all([this.getDataDashboard(), this.getBoxDashboard()])
    .then(() =>{

      let categories = this.items.map(function(item) {
          return item.name.toString()
      }).sort()

      this.chartOptions = {
        colors: ['#8e978d', '#97c4ad', '#bfedbe', '#e6fcd9', '#cdf2d6',
        '#8e978d', '#97c4ad', '#bfedbe', '#e6fcd9', '#cdf2d6','#8e978d', '#97c4ad'],
        chart: {
          type: 'column'
        },
  	    title: {
  	      text: 'Total cajas por año'
  	    },
  	    subtitle: {
  	      text: 'Datos tomados de cada gestión.'
  	    },
  	    xAxis: {
  	      categories: categories,
  	      crosshair: true
  	    },
  	    yAxis: {
  	      min: 0,
  	      title: {
  	        text: 'Cantidad'
  	      }
  	    },
        legend: {
          backgroundColor: '#E0E0E8',
          itemStyle: {
            fontWeight: 'bold',
            fontSize: '13px'
          }
        },
  	    tooltip: {
  	      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
  	      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
  	      '<td style="padding:0"><b>{point.y}</b></td></tr>',
  	      footerFormat: '</table>',
  	      shared: true,
  	      useHTML: true
  	    },
        series: [
          {
            name: 'Gestiones',
            colorByPoint: true,
            data: this.items
          }
        ]
      }

      this.success = true
    })
  },

  methods: {
  	getDataDashboard: async function() {
      const response = await ReportService.getDataDashboard()
      if (response.status === 200) {
        this.moves = response.data
      }
    },

    getBoxDashboard: async function() {
      const response = await ReportService.getBoxDashboard()
      if (response.status === 200) {
        this.items = response.data
      }
    }

  },

  components: {
    ListPanel,
    highcharts: Chart,
  },
}
</script>


